/**
 * UPMI — Products page (handoff Page 2). Keeps the target system's marketplace
 * layout (the shared section components) but wraps it in the upmi chrome so it
 * matches the other bespoke pages. Sections come from the tenant's `/storefront`
 * layout page (falls back to the Omni default).
 */
import { LAYOUT_DEFAULT_OMNI } from '@mlm/shared';
import { SectionRenderer } from '../../../storefront/components/section-renderer';
import { useStorefrontContent } from '../../../storefront/lib/hooks';
import { UpmiShell } from './shell';

export function UpmiProducts(): JSX.Element {
  const layout = useStorefrontContent().data.layout ?? LAYOUT_DEFAULT_OMNI;
  const page =
    layout.pages.find((p) => p.path === '/storefront') ??
    LAYOUT_DEFAULT_OMNI.pages.find((p) => p.path === '/storefront');
  return (
    <UpmiShell active="products">
      <div className="omni-store">
        <div className="mx-auto max-w-[1180px] px-4 py-4">
          <SectionRenderer sections={page?.sections ?? []} />
        </div>
      </div>
    </UpmiShell>
  );
}
